/* eslint-disable no-unused-vars */
import React from 'react';
import $ from 'jquery';

import './FlightChangePage.css';
import FlightChangeContainer from './components/FlightChangeContainer';
import MenuBar from '../../components/menuBar/MenuBar';
import { Redirect } from 'react-router-dom';
import OverviewBreadcrumb from '../../components/overviewSearchBar/overviewBreadcrumb/OverviewBreadcrumb';
import InfoModal from '../../components/searchBox/infoModal/InfoModal';
import PropTypes from 'prop-types';
import Moment from 'moment';
import axios from 'axios';
import Features from '../../const/Features';
import MomentTZ from 'moment-timezone';
import { fetchLoader } from '../../components/utils/FetchLoader';
import FeatureService from './../../services/feature/FeatureService.js';

var GET_AVAILABILITY_V1 = 'catalog/api/v1/availability?';
var GET_AIRPORTS_V1 = 'catalog/api/v1/airport?';
var FEATURE_TOGGLE_URL = '/feature/check';

const I18n = require('i18n-react').default;

const propTypes = {
  location: PropTypes.object
};

let ECONOMY_LABEL;
let BUSINESS_LABEL;

const cabinType = {
  ECONOMY: 'ECONOMY',
  BUSINESS: 'BUSINESS'
};

class FlightChangePage extends React.Component {
  constructor(props) {
    super(props);

    ECONOMY_LABEL = 'Econômica';
    BUSINESS_LABEL = 'Executiva';

    this.state = {
      flightOrigin: null,
      flightDestiny: null,
      flightBackOrigin: null,
      flightBackDestination: null,
      startDate: null,
      endDate: null,
      minSelectionDate: null,
      maxSelectionDate: null,
      selectCabinCategory: ECONOMY_LABEL,
      cabinCategory: cabinType.ECONOMY,
      typeOfFlight: 'A',
      isRedirect: false,
      urlRedirect: '/',
      isSelectedDestiny: this.props.location.state.isSelectedDestiny,
      isSelectedOrigin: this.props.location.state.isSelectedOrigin,
      isSearchDeeplinkEnabled: false,
      showAdditionalFields: false,
      featureHomeValidationService: false,
    };

    this.changeValue = this.changeValue.bind(this);
    this.setTypeOfFlight = this.setTypeOfFlight.bind(this);
    this.setFlightOrigin = this.setFlightOrigin.bind(this);
    this.setFlightDestiny = this.setFlightDestiny.bind(this);
    this.setFlightBackOrigin = this.setFlightBackOrigin.bind(this);
    this.setFlightBackDestiny = this.setFlightBackDestiny.bind(this);
    this.handlerStartDate = this.handlerStartDate.bind(this);
    this.handlerEndDate = this.handlerEndDate.bind(this);
    this.handleAirportSearch = this.handleAirportSearch.bind(this);
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentWillMount() {
    this.fillDeeplinkToggle();

    FeatureService.isFeatureEnabled(Features.HOME_VALIDATION_SERVICE).then(isEnabled => {
      this.setState({
        featureHomeValidationService: isEnabled
      });
    });
  }

  fillDeeplinkToggle() {
    FeatureService.isFeatureEnabled(Features.HOME_SEARCH_DEEPLINK).then(isEnabled => {
      this.setState({
        isSearchDeeplinkEnabled: isEnabled
      });
    });
  }

  setFlightOrigin(value) {
    this.setState({
      flightOrigin: value,
      showAdditionalFields: true
    });
    if (!this.state.isSelectedOrigin && this.state.isSelectedDestiny) {
      $('input#autocompleteFlightBackDestination').focus();
    } else {
      $('input#autocompleteFlightDestination').focus();
    }
  }

  setFlightDestiny(value) {
    this.setState({
      flightDestiny: value
    });
    if (!this.state.isSelectedOrigin && this.state.isSelectedDestiny) {
      $('#calendarEndDate_group input').focus();
    } else if (this.state.isSelectedOrigin && !this.state.isSelectedDestiny) {
      $('#calendarStartDate_group input').focus();
    } else {
      $('input#autocompleteFlightBackOrigin').focus();
    }
  }

  setFlightBackOrigin(value) {
    this.setState({
      flightBackOrigin: value,
      showAdditionalFields: true
    });
    $('input#autocompleteFlightBackDestination').focus();
  }

  setFlightBackDestiny(value) {
    this.setState({
      flightBackDestination: value
    });
    $('#calendarStartDate_group input').focus();
  }

  handlerStartDate(value) {
    this.setState({
      startDate: value
    });
    $('#calendarEndDate_group input').focus();
  }

  handlerEndDate(value) {
    this.setState({
      endDate: value
    });
    $('#CabinCategory_SelectBoxId').focus();
  }

  setTypeOfFlight(value) {
    this.setState({
      typeOfFlight: value
    });
  }

  handleAirportSearch(searchTerm, airport) {
    const reqfilter = {
      searchAirport: searchTerm
    };

    if (airport) {
      reqfilter.ignoreCode = airport.searchCode === '1N' ? '1N' : '';
      reqfilter.ignoreAirport = airport.code;
    }

    const query = Object.keys(reqfilter)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(reqfilter[key]))
      .join('&');

    return fetch(GET_AIRPORTS_V1 + query)
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw Error();
        }
      })
      .catch(() => {
        this.showModal(I18n.translate('home.msg.error'));
        return [];
      });
  }

  changeValue(value) {
    this.setState({
      selectCabinCategory: value,
      cabinCategory: value === ECONOMY_LABEL ? cabinType.ECONOMY : cabinType.BUSINESS
    });
  }

  showModal(message) {
    this.setState({
      openModal: true,
      messageInfo: message
    });
  }

  closeModal() {
    if (this.state.modalInactivity && this.callCenterMode()) {
      document.location.assign(global.env.CALLCENTER_LOGOUT_URL);
    } else {
      this.setState({
        openModal: false,
        messageInfo: null
      });
    }
  }

  handleSearchDeeplink = filter => {
    let deepLink = this.buildDeeplink(filter);
    this.setState({
      urlRedirect: deepLink,
      isRedirect: true,
      filter: filter
    });
  };

  handleSearch = () => {
    const filter = {
      typeTrip:
        this.props.location.state.isSelectedOrigin !== this.props.location.state.isSelectedDestiny
          ? 'oneWay'
          : 'roundTrip',
      flightOrigin: {
        code: this.state.flightOrigin.code,
        searchCode: this.state.flightOrigin.searchCode,
        name: this.state.flightOrigin.name
      },
      flightDestiny: {
        code: this.state.flightDestiny.code,
        searchCode: this.state.flightDestiny.searchCode,
        name: this.state.flightDestiny.name
      },
      minSelectionDate: this.state.minSelectionDate,
      maxSelectionDate: this.state.maxSelectionDate,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      totalAdults: this.props.location.state.passengersInfo.adultPassengers,
      totalKids: this.props.location.state.passengersInfo.childrenPassengers,
      totalBabys: this.props.location.state.passengersInfo.infantPassengers,
      openModal: this.state.openModal,
      showAdditionalFields: this.state.showAdditionalFields,
      featureHomeValidationService: this.state.featureHomeValidationService,
      selectCabinCategory: this.state.selectCabinCategory,
      cabinCategory: this.state.cabinCategory,
      typeOfFlight: this.state.typeOfFlight,
      companiesIdentity: ''
    };
    if (this.state.isSearchDeeplinkEnabled) {
      this.handleSearchDeeplink(filter);
    } else {
      this.handleSearchWithAvailability(filter);
    }
  };

  handleSearchWithAvailability(filter) {
    this.setFilter(filter);

    const reqfilter = {
      tripType: filter.typeTrip === 'roundTrip' ? 'ROUND_TRIP' : 'ONE_WAY',
      origin: filter.flightOrigin.code,
      destination: filter.flightDestiny.code,
      adult: filter.totalAdults,
      child: filter.totalKids,
      infant: filter.totalBabys
    };

    reqfilter.departureDateTime = MomentTZ(filter.startDate).format();
    if (filter.endDate) {
      reqfilter.returnDateTime = MomentTZ(filter.endDate).format();
    }

    const query = Object.keys(reqfilter)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(reqfilter[key]))
      .join('&');

    fetchLoader(GET_AVAILABILITY_V1 + query)
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw Error();
        }
      })
      .then(responseJson => {
        this.updateCookies(filter);
        this.setState({
          isRedirect: true,
          urlRedirect: '/flightChangeSearch',
          result: responseJson,
          filter: filter
        });
      })
      .catch(error => {
        this.showModal(I18n.translate('home.msg.error'));
      });
  }

  isFeatureEnabled(feature) {
    if (!window.featureStatus[feature.name]) {
      window.featureStatus[feature.name] = new Promise(resolve => {
        axios
          .get(`${FEATURE_TOGGLE_URL}?feature=${feature.name}`)
          .then(response => {
            resolve(response.data);
          })
          .catch(() => {
            resolve(false);
          });
      });
    }

    return window.featureStatus[feature.name];
  }

  buildDeeplink() {
    const {
      isSelectedDestiny,
      isSelectedOrigin,
      startDate,
      endDate,
      flightOrigin,
      flightDestiny,
      typeOfFlight,
      cabinCategory
    } = this.state;

    const {
      adultPassengers,
      childrenPassengers,
      infantPassengers
    } = this.props.location.state.passengersInfo;
    const typeTrip = isSelectedDestiny !== isSelectedOrigin ? 'OW' : 'RT';
    const startDateTrip = Moment(startDate).format('YYYY-MM-DD');
    const endDateTrip = endDate ? Moment(endDate).format('YYYY-MM-DD') : '-';
    const flightOriginTrip = flightOrigin.code;
    const flightDestinyTrip = flightDestiny.code;
    const typeOfFlightTrip = typeOfFlight !== null ? typeOfFlight : 'A';
    const companiesIdentity = '-';

    let deepLink = '';

    const cabinCategoryTrip = cabinCategory;
    deepLink = `/flightChangeSearch/${typeTrip}/${flightOriginTrip}/${flightDestinyTrip}/-/-/${startDateTrip}/${endDateTrip}/${adultPassengers}/${childrenPassengers}/${infantPassengers}/0/0/ALL/F/${cabinCategoryTrip}/-/-/-/-/${typeOfFlightTrip}/${companiesIdentity}`;
    return deepLink;
  }

  render() {
    const {
      flightOrigin,
      flightDestiny,
      typeOfFlight,
      flightBackOrigin,
      flightBackDestination,
      startDate,
      endDate,
      minSelectionDate,
      maxSelectionDate,
      selectCabinCategory,
      isSelectedDestiny,
      isSelectedOrigin
    } = this.state;

    return (
      <div>
        <MenuBar hideChangeSearch={true} />
        <OverviewBreadcrumb
          id="componentOverviewBreadcrumb"
          steps={[
            'features.breadcrumb.reservation',
            'features.breadcrumb.pnrDetail',
            'features.breadcrumb.change'
          ]}
          actual="features.breadcrumb.change"
        />
        <div id="FlightChangePage">
          <div className="container section__outer">
            <div className="flight-change-page">
              <FlightChangeContainer
                flightOrigin={flightOrigin}
                flightDestination={this.flightDestination}
                flightDestiny={flightDestiny}
                flightBackOrigin={flightBackOrigin}
                flightBackDestination={flightBackDestination}
                startDate={startDate}
                endDate={endDate}
                setFlightOrigin={this.setFlightOrigin}
                setFlightDestiny={this.setFlightDestiny}
                setFlightBackOrigin={isSelectedDestiny !== isSelectedOrigin ? this.setFlightOrigin : this.setFlightBackOrigin}
                setFlightBackDestiny={isSelectedDestiny !== isSelectedOrigin ? this.setFlightDestiny : this.setFlightBackDestiny}
                setTypeOfFlight={this.setTypeOfFlight}
                handlerFocusStartDate={this.handlerFocusStartDate}
                handlerStartDate={this.handlerStartDate}
                handlerEndDate={isSelectedDestiny !== isSelectedOrigin ? this.handlerStartDate : this.handlerEndDate}
                changeValue={this.changeValue}
                minSelectionDate={minSelectionDate}
                maxSelectionDate={maxSelectionDate}
                selectCabinCategory={selectCabinCategory}
                typeOfFlight={typeOfFlight}
                economyLabel={ECONOMY_LABEL}
                businessLabel={BUSINESS_LABEL}
                handleAirportSearch={this.handleAirportSearch}
                handleProceed={this.handleSearch}
                isSelectedDestiny={isSelectedDestiny}
                isSelectedOrigin={isSelectedOrigin}
              />
            </div>
          </div>
        </div>
        <InfoModal
          id="modalSearchInfo"
          message={this.state.messageInfo}
          showModal={this.state.openModal}
          close={this.closeModal}
          ref={c => {
            this.modalSearchInfo = c;
          }}
        />
        {this.state.isRedirect ? (
          <Redirect
            push
            to={{
              pathname: this.state.urlRedirect,
              state: {
                result: this.state.result,
                filter: this.state.filter,
                pnrNumber: this.props.location.state.pnrNumber,
                azulNumber: this.props.location.state.azulNumber
              },
              search: this.props.location.search
            }}
          />
        ) : null}
      </div>
    );
  }
}

FlightChangePage.propTypes = propTypes;

export default FlightChangePage;



// WEBPACK FOOTER //
// ./src/page/flightChange/FlightChangePage.jsx